import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/leadFunctions/proposalTemplateActions'
import * as api from '../../api/lead/templates'

function* getProposalTemplates(action) {
  try {
    const payload = yield call(api.getProposalTemplates, action.jobId)
    yield put({ type: constants.GET_PROPOSAL_TEMPLATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_PROPOSAL_TEMPLATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetProposalTemplates() {
  yield takeLatest(constants.GET_PROPOSAL_TEMPLATES.ACTION, getProposalTemplates)
}

function* getTemplateSections(action) {
  try {
    const payload = yield call(api.getProposalTemplateSections, action.templateId)
    yield put({ type: constants.GET_PROPOSAL_TEMPLATE_SECTIONS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_PROPOSAL_TEMPLATE_SECTIONS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetTemplateSections() {
  yield takeLatest(constants.GET_PROPOSAL_TEMPLATE_SECTIONS.ACTION, getTemplateSections)
}

function* getTemplateItems(action) {
  try {
    const payload = yield call(api.getProposalTemplateItems, action.templateId)
    yield put({ type: constants.GET_PROPOSAL_TEMPLATE_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_PROPOSAL_TEMPLATE_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetTemplateItems() {
  yield takeLatest(constants.GET_PROPOSAL_TEMPLATE_ITEMS.ACTION, getTemplateItems)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchGetProposalTemplates),
    fork(watchGetTemplateSections),
    fork(watchGetTemplateItems)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadFunctions/proposalTemplateSaga.js